"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerBreadcrumbItem = exports.BmBreadcrumbItem = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmIcon = require("./bm-icon");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["<bm-icon type=", " />"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<button type=\"button\" @click=\"", "\">", "</button>\n\t\t\t", "\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tfont-size: 16px;\n\t\tfont-family: Arial, 'Helvetica Neue', sans-serif;\n\t}\n\t:host([disabled]) {\n\t\tcolor: #000000;\n\t}\n\t:host([disabled]) button {\n\t\tcolor: #000000;\n\t\tcursor: text;\n\t}\n\t:host([disabled]) button:hover {\n\t\ttext-decoration: none;\n\t}\n\t:host button {\n\t\tborder: none;\n\t\tbackground: transparent;\n\t\tfont-size: 16px;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\ttext-decoration: none;\n\t\tcolor: #0072a8;\n\t\toutline: none;\n\t}\n\t:host button:hover {\n\t\ttext-decoration: underline;\n\t}\n\t:host bm-icon {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmBreadcrumbItem = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmBreadcrumbItem, _BlueElement);

  var _super = (0, _createSuper2.default)(BmBreadcrumbItem);

  (0, _createClass2.default)(BmBreadcrumbItem, null, [{
    key: "is",
    get: function get() {
      return 'bm-breadcrumb-item';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        label: {
          type: String,
          attribute: false,
          reflect: false
        },
        url: {
          type: String,
          attribute: false,
          reflect: false
        },
        icon: {
          type: String,
          attribute: false,
          reflect: false
        },
        disabled: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmBreadcrumbItem() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmBreadcrumbItem);
    _this = _super.call(this);
    _this.label = '';
    _this.url = '';
    _this.icon = '';
    _this.disabled = true;
    _this.onItemClick = (0, _bind.default)(_context = _this.onItemClick).call(_context, (0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(BmBreadcrumbItem, [{
    key: "onItemClick",
    value: function onItemClick(event) {
      event.preventDefault();

      if (!this.disabled) {
        var item = {
          label: this.label,
          url: this.url,
          icon: this.icon,
          disabled: this.disabled
        };
        this.dispatchEvent(new CustomEvent('item-click', {
          detail: {
            item: item
          }
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.html(_templateObject2(), this.onItemClick, this.label, (0, _element.guard)(this.icon, function () {
        return _this2.renderIcon();
      }));
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      if (this.icon) {
        return this.html(_templateObject3(), this.icon);
      }

      return _element.nothing;
    }
  }]);
  return BmBreadcrumbItem;
}(_element.BlueElement);

exports.BmBreadcrumbItem = BmBreadcrumbItem;

var registerBreadcrumbItem = function registerBreadcrumbItem() {
  (0, _bmIcon.registerIcon)();
  (0, _element.register)(BmBreadcrumbItem);
};

exports.registerBreadcrumbItem = registerBreadcrumbItem;
